/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBTITLE = {
    Professor: 'PROFESS',
    Admiral: 'ADMIRAL',
    Mrs: 'MRS',
    Bishop: 'BISHOP',
    Magistrate: 'MAGISTRATE',
    Dr: 'DOCTOR',
    Doctor: 'DOCTOR2',
    Sir: 'SIR',
    MajorGen: 'MAJORGEN',
    Princess: 'PRINC',
    Lieutenant: 'LIEUTENANT',
    Miss: 'MISS',
    Rabbi: 'RABBI',
    Mr: 'MR',
    Father: 'FATHER',
    Advocate: 'ADVOCATE',
    Colonel: 'COLONEL',
    Mayor: 'MAYOR',
    Minister: 'MINISTER',
    Pastor: 'PASTOR',
    Brigadier: 'BRIGADIER',
    Sergeant: 'SERGEANT',
    Inspector: 'INSPECTOR',
    EstLate: 'ESTLATE',
    Sup: 'SUP',
    Reverend: 'REVEREND',
    Ms: 'MS',
    LtCmdr: 'LTCMDR',
    Prince: 'PRINCE',
    LieutCol: 'LIEUTCOL',
    SnrSup: 'SNRSUP',
    JusticeOrJudge: '8',
    Major: 'MAJOR',
    Commissioner: 'COMMISSIONER',
    Commodore: 'COMMODORE',
    Lady: 'LADY',
    TheHon: 'THEHON',
    Honourable: 'HONOURABLE',
    Master: 'MASTER',
    Director: 'DIRECTOR',
    Sister: 'SISTER',
    President: 'PRESIDENT',
    Captain: 'CAPTAIN',
    General: 'GENERAL',
    Judge: 'JUDGE'
} as const;
export type GHUBTITLE = typeof GHUBTITLE[keyof typeof GHUBTITLE];


export function GHUBTITLEFromJSON(json: any): GHUBTITLE {
    return GHUBTITLEFromJSONTyped(json, false);
}

export function GHUBTITLEFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBTITLE {
    return json as GHUBTITLE;
}

export function GHUBTITLEToJSON(value?: GHUBTITLE | null): any {
    return value as any;
}

